import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './index.css';

// Import the marker icons directly
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// Set up the default icon correctly
const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Set the default icon for all markers
L.Marker.prototype.options.icon = DefaultIcon;

const position = [-37.5376661, 144.9561794]; // Melbourne, Australia

function App() {
  return (
    <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ height:'50vh', width:'100%' }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position}>
        <Popup>
          <a 
          target='_blank' 
          rel="noopener noreferrer"
          href="https://www.google.com/maps/place/12+Klandy+Dr,+Kalkallo+VIC+3064,+Australia/@-37.5377132,144.9535968,17z/data=!3m1!4b1!4m6!3m5!1s0x6ad652a8b64c38cb:0x53109829bbf72ebf!8m2!3d-37.5377175!4d144.9561717!16s%2Fg%2F11tcvh237y?entry=ttu&g_ep=EgoyMDI1MTIwOC4wIKXMDSoASAFQAw%3D%3D">
            12 Klandy Drive Kalkallo, VIC, 3064, Australia.
          </a>
        </Popup>
      </Marker>
    </MapContainer>
  );
}

export default App;